import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../Components/AuthContext';
import styles from './RequireAuth.module.css';

const RequireAuth: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className={styles.loaderScreen}>
        <span className={styles.spinner} aria-label="Loading" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
